function initNewsletterForm() {
    $('.newsletter-link').click(function(event) {
        event.preventDefault();
        $('#newsletterModal').modal();
    });
    let queryString = window.location.search;
    if (queryString && queryString.indexOf("newsletter=1") !== -1) {
        $('#newsletterSuccessModal').modal();
    }
}